import React, { useRef, useState } from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import Notif from "../../Icons/notif.jpg";
import { useModal } from "../../../Store/modules/modal/modal";
import { NotificationTypes } from "../../../Schema/notification.types";
import { Icon, Text } from "../../Kit";
import { Button } from "../../Kit/Button";
import { useSeenAnnouncedNotification } from "../../../Store/modules/ai/postSeenAnnouncedNotification/postSeenAnnouncedNotification";
import { Play, PlayCircle } from "iconsax-react";

export const AnnouncedNotificationModal: React.FC = () => {
  const { modalProps } = useModal();
  const props: NotificationTypes & { router: any; ignoreSeen: boolean } = modalProps || {};
  const { id, title, content, links, image, video, ignoreSeen } = props;
  const videoRef = useRef<any>();
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const { dispatchSeenAnnouncedNotification } = useSeenAnnouncedNotification();

  const handleSeenNotif = () => {
    if (!ignoreSeen) {
      dispatchSeenAnnouncedNotification({ id });
    }
  };

  const handleNavigateToAnchor = (link: string) => {
    window.location.href = link;
  };

  const pleyVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <Modal
      modalName={ModalNames.AnnouncedNotification}
      modalClassName="rounded-[10px] md:w-[500px] xs:w-[95%] h-auto"
      ignorePadding
      preventToClose
      onCloseAction={handleSeenNotif}
      showCloseIcon
    >
      <div>
        {image ? <img src={image} className="md:max-h-[480px] xs:w-full" alt="notif" /> : null}

        {video ? (
          <div className="relative md:h-[280px] xs:w-full">
            <video
              src={video}
              controls
              ref={videoRef}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              className="md:h-[280px] xs:w-full"
            />
            {!isPlaying ? (
              <Icon
                Component={PlayCircle}
                onClick={pleyVideo}
                size={100}
                color="text"
                className="opacity-30 absolute left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%] "
              />
            ) : null}
          </div>
        ) : null}

        {!image && !video ? (
          <img src={Notif} className="md:h-[224px] xs:w-full" alt="notif" />
        ) : null}

        <Text elementType="p" fontWeight={500} className="text-xl text-center mt-[23px] px-4">
          {title}
        </Text>
        <Text elementType="p" fontWeight={300} className="text-sm text-justify mt-[15px] px-6">
          {content}
        </Text>
        <div className="mt-[20px] w-full px-6 pb-[22px] flex xs:flex-col lg:flex-row justify-between">
          {links
            ? JSON.parse(links)?.map((link: { link: string; anchor: string }) => (
                <div
                  className="w-full"
                  onClick={() => {
                    handleSeenNotif();
                    handleNavigateToAnchor(link.link);
                  }}
                >
                  <Button
                    title={link.anchor}
                    bg="primary"
                    textColor="white"
                    className="w-full h-[36px] text-sm"
                  />
                </div>
              ))
            : null}
        </div>
      </div>
    </Modal>
  );
};
